import NiceModal, {useModal} from '@ebay/nice-modal-react';
import {
  useLivraisonsPossiblesContext,
  useRemoveAllModal,
  useSelectedLivraison,
} from 'ff-common';
import {useCallback} from 'react';
import {Box, HStack, Text, VStack} from '@chakra-ui/react';
import {useTranslation} from 'react-i18next';
import {ModaleLayout} from '../ModaleLayout';
import {ChevronLeftBlueIcon} from '@/components/svg/ChevronLeftBlueIcon';
import {Calendar} from './Calendar/Calendar';
import {LegendeCalendrier} from './LegendeCalendrier';
import {OrderModalIcon} from '@/components/svg/OrderModalIcon';

export const OuvrirPanierModale = NiceModal.create(() => {
  const modal = useModal();
  const {t} = useTranslation();
  const removeAllModals = useRemoveAllModal();

  const {livraisonSelectionnee, setLivraisonSelectionnee} =
    useLivraisonsPossiblesContext();

  const {selectedLivraison, onDateSelect, onCancel} = useSelectedLivraison(
    livraisonSelectionnee,
    setLivraisonSelectionnee,
    modal,
  );

  const onValidate = useCallback(async () => {
    // Met à jour la date de livraison sélectionnée et ferme toutes les modales
    setLivraisonSelectionnee(selectedLivraison);
    removeAllModals();
  }, [selectedLivraison, setLivraisonSelectionnee, removeAllModals]);

  const customHeader = (
    <HStack
      w='100%'
      alignItems='center'
    >
      <HStack
        cursor='pointer'
        onClick={() => {
          modal.hide();
        }}
      >
        <ChevronLeftBlueIcon color='gray.dark' />
        <Text color='gray.dark'>{t('global.retour')}</Text>
      </HStack>
    </HStack>
  );

  return (
    <ModaleLayout
      visible={modal.visible}
      hide={modal.remove}
      titre={customHeader}
      contentStyle={{width: '100%'}}
      onCancel={onCancel}
      drawerPlacement='bottom'
      drawerSize='auto'
    >
      <VStack
        alignItems='stretch'
        w='100%'
      >
        <VStack alignItems='stretch'>
          <HStack
            alignItems='center'
            gap={2}
            my={2}
          >
            <OrderModalIcon color='black' />
            <Text fontWeight='500'>{t('modale_livraison.header.ouvrir')}</Text>
          </HStack>
          <Box
            border='1px solid'
            borderColor='gray.light'
            borderRadius='8px'
            p='2'
          >
            <Calendar
              onCancel={onCancel}
              onDateSelect={onDateSelect}
              onValidate={onValidate}
              selectedLivraison={selectedLivraison}
            />
          </Box>
        </VStack>
        <LegendeCalendrier />
      </VStack>
    </ModaleLayout>
  );
});
